function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPenname = function SvgPenname(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.5 26.763"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 33367"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 31888"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 21971",
    style: {
      stroke: "currentColor",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.286 0a4.286 4.286 0 0 1 4.285 4.286v1a1.531 1.531 0 0 1-1.53 1.532h-5.51A1.531 1.531 0 0 1 0 5.288v-1A4.286 4.286 0 0 1 4.286 0z",
    style: {
      stroke: "none"
    },
    transform: "translate(2.75 9.274)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.286.5a3.786 3.786 0 0 1 3.785 3.786v.771A1.262 1.262 0 0 1 6.81 6.318H1.762A1.262 1.262 0 0 1 .5 5.056v-.77A3.786 3.786 0 0 1 4.286.5z",
    style: {
      fill: "none"
    },
    transform: "translate(2.75 9.274)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 1873",
    transform: "translate(4.464 5.297)",
    style: {
      stroke: "currentColor",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.571,
    cy: 2.557,
    rx: 2.571,
    ry: 2.557,
    style: {
      stroke: "none"
    },
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.571,
    cy: 2.557,
    rx: 2.071,
    ry: 2.057,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1042",
    transform: "translate(5.321 13.536)",
    style: {
      strokeLinecap: "round",
      stroke: "currentColor",
      fill: "none"
    },
    d: "M0 0v2.273"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1043",
    transform: "translate(8.75 13.536)",
    style: {
      strokeLinecap: "round",
      stroke: "currentColor",
      fill: "none"
    },
    d: "M0 0v2.273"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19934",
    d: "M23 7.2V30m0-22.8A21.966 21.966 0 0 0 13 5 21.966 21.966 0 0 0 3 7.2V30a21.966 21.966 0 0 1 10-2.2A21.966 21.966 0 0 1 23 30m0-22.8A21.966 21.966 0 0 1 33 5a21.959 21.959 0 0 1 10 2.2V30a21.959 21.959 0 0 0-10-2.2A21.966 21.966 0 0 0 23 30",
    transform: "translate(-2.25 -4.25)",
    style: {
      strokeWidth: "1.5px",
      strokeLinejoin: "round",
      strokeLinecap: "round",
      stroke: "#3f54d9",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19935",
    d: "M4.275.785 5.51 2.027M4.8.257a.87.87 0 0 1 1.236 0 .882.882 0 0 1 0 1.243L1.223 6.339H0V5.084z",
    transform: "rotate(-90 11.812 .042)",
    style: {
      strokeLinejoin: "round",
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19936",
    d: "M-12516.562-20563.072a24.566 24.566 0 0 1 15.107 0",
    transform: "translate(12519.562 20585.313)",
    style: {
      strokeDasharray: "2 3",
      strokeLinecap: "round",
      stroke: "currentColor",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19940",
    d: "M-12516.562-20563.064a24.445 24.445 0 0 1 11.839-.8",
    transform: "translate(12540.134 20585.303)",
    style: {
      strokeDasharray: "2 3",
      strokeLinecap: "round",
      stroke: "currentColor",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19942",
    d: "M-12516.562-20563.064a24.445 24.445 0 0 1 11.839-.8",
    transform: "translate(12540.134 20572.053)",
    style: {
      strokeDasharray: "2 3",
      strokeLinecap: "round",
      stroke: "currentColor",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19943",
    d: "M-12511.732-20563.807a25.1 25.1 0 0 1 12.348.73",
    transform: "translate(12538.064 20579.634)",
    style: {
      strokeDasharray: "2 3",
      strokeLinecap: "round",
      stroke: "currentColor",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19938",
    d: "M-12516.562-20563.072a24.566 24.566 0 0 1 15.107 0",
    transform: "translate(12519.562 20582.472)",
    style: {
      strokeDasharray: "2 3",
      strokeLinecap: "round",
      stroke: "currentColor",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19939",
    d: "M-12516.562-20563.072a24.566 24.566 0 0 1 15.107 0",
    transform: "translate(12540.134 20582.472)",
    style: {
      strokeDasharray: "2 3",
      strokeLinecap: "round",
      stroke: "currentColor",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19941",
    d: "M-12510.128-20563.967a25.111 25.111 0 0 1 11.432.891",
    transform: "translate(12537.377 20569.226)",
    style: {
      strokeDasharray: "2 3",
      strokeLinecap: "round",
      stroke: "currentColor",
      fill: "none"
    }
  })));
};

export default SvgPenname;